// extracted by mini-css-extract-plugin
export default {"container":"LeaderboardSection_container__-9bKQ"};